import React, { ReactNode } from 'react';
import clsx from 'clsx';

import * as styles from './ui-option-button.scss';

export interface UIOptionButtonProps {
  className?: string;
  icon?: ReactNode;
  onClick?: (value?: string) => void;
  selected?: boolean;
  style?: React.CSSProperties;
  text?: ReactNode;
  value?: string;
}

export const UIOptionButton = (props: UIOptionButtonProps) => {
  const { className, icon, onClick, selected, style, text, value } = props;

  return (
    <div
      className={clsx(className, styles.button, {
        [styles.selected]: selected
      })}
      style={style}
      onClick={() => onClick?.(value)}
    >
      {icon && <div className={styles.icon}>{icon}</div>}
      <div className={styles.text}>{text}</div>
    </div>
  );
};
